<template>
    <b-taginput
        @typing="debouncedSearch"
        @input="onInput"
        v-bind="$attrs"
        v-model="model"
        autocomplete
        :loading="isLoading"
        :data="items"
        field="user.full_name"
    >
    </b-taginput>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
        },
        filter: {
            type: Object,
        },
        ignoreIds: {
            type: Array,
        },
    },
    data() {
        return {
            items: [],
            isLoading: false,
            model: this.value,
        };
    },
    computed: {
        debouncedSearch() {
            return _.throttle(this.search, 500);
        },
    },
    methods: {
        onInput(value) {
            this.$emit("update", value);
        },
        search(name) {
            if (name.length >= 0) {
                this.isLoading = true;

                axios
                    .get(`/api/users`, {
                        params: _.merge(this.filter, {
                            limit: 5,
                            name,
                        }),
                    })
                    .then(({ data: { data } }) => {
                        data = _.map(data, (u) => {
                            return { user: u };
                        });

                        let ignoreIds = _.map(this.model, "user.id");

                        if (this.$user) {
                            ignoreIds.push(this.$user.id);
                        }

                        if (this.ignoreIds) {
                            for (let id of this.ignoreIds) {
                                ignoreIds.push(id);
                            }
                        }

                        data = _.filter(data, (item) => {
                            return ignoreIds.includes(item.user.id) == false;
                        });

                        this.items = data;
                    })
                    .catch((error) => {
                        // Omit load error.
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/UserListInput.vue